<template>
  <div class="layer" :class="{callStaffItem: isCallStaff}">
    <div class="inner" :class="{inner520: isCallStaff}">
      <button type="button" class="btnClose" @click="close"></button>
      <div class="layerTitle">
        <h2>{{ isCallStaff ? locale.call_staff : locale.product }}</h2>

        <!-- duplicate item -->
        <div class="duplicateShopItem">
          <span class="checkbox">
            <input type="checkbox" id="duplicate_with_pid" v-model="duplicateWithPid">
            <label for="duplicate_with_pid">{{ locale.include_pid }}</label>
          </span>
          <button type="button" class="btn sizeS mr5" @click="duplicateItem(false)">{{ locale.duplicate_with_add }}</button>
          <button type="button" class="btn btnBlue sizeS" @click="duplicateItem(true)">{{ locale.duplicate_with_replace }}</button>
        </div>
        <!-- //duplicate item -->

      </div>
      <div class="innerContent">
        <div class="info">
          <div class="mb10">
            <div class="innerTitle">
              <div class="checkbox">
                <input type="checkbox" id="item_activate" v-model="isActive">
                <label for="item_activate">{{ locale.activate }}</label>
              </div>
            </div>
          </div>
          <div v-if="!(isBaseShopPos && pId)">
            <div class="innerTitle">
              <div class="checkbox">
                <input type="checkbox" id="item_is_call_only" v-model="isCallItem">
                <label for="item_is_call_only">{{ locale.exclude_order_history }}</label>
              </div>
            </div>
          </div>
          <!-- 관리용 이름 -->
          <div class="mt30 mb30">
            <div class="innerTitle setLabel">{{locale.title}}</div>
            <input type="text" class="input" v-model="title">
          </div>
          <!-- 관리용 이름 -->
          <!-- 상품명 -->
          <div class="mb30 isRequired">
            <div class="innerTitle setLabel">{{locale.name}}</div>
            <SetLanguageValue
              :locale="locale"
              :langValue="name"
              :disabledLangCodes="disabledLangCodes" />
            <div v-if="(isBaseShopPos && shopItemId !== 'new')" class="mt10">
              <div class="checkbox">
                <input type="checkbox" id="replace_name_pos" v-model="allowReplaceItemName">
                <label for="replace_name_pos">{{ locale.shop_separate_display_name }}</label>
              </div>
            </div>
          </div>
          <!-- //상품명 -->
          <!-- pid -->
          <div class="mb30">
            <div class="innerTitle setLabel">{{locale.product_id}}</div>
            <input type="text" class="input" :disabled="isBaseShopPos" v-model="pId">
          </div>
          <!-- //pid -->
          <!-- 금액 -->
          <div class="mb30 isRequired">
            <div class="innerTitle setLabel">{{locale.price}}</div>
            <input type="text" class="input" :disabled="isBaseShopPos && pId?.length > 0" v-model="price" @keyup="setPrice">
            <div v-if="!isCallStaff" class="mt10">
              <div class="checkbox">
                <input type="checkbox" id="display_option_price" v-model="replaceOptionPrice">
                <label for="display_option_price">{{locale.price_by_options}}</label>
              </div>
            </div>
          </div>
          <!-- //금액 -->
          <!-- 카테고리 -->
          <div v-if="!isOptItem" class="isRequired">
            <div class="innerTitle setLabel">{{locale.category}}</div>
            <button class="btn btnWhite btnFull toUppercase" @click="openShopCategory">{{ locale.setting }}</button>
          </div>
          <!-- //카테고리 -->
        </div>
        <div v-if="!isCallStaff" class="info">
          <!-- 수량 -->
          <div class="mb30 isRequired">
            <div class="innerTitle setLabel">{{locale.quantity}}</div>
            <div class="flexContainer mb10">
              <div class="flexItem mr5">
                {{ locale.min }} <input type="text" class="input sizeS" v-model="quantity.min" @keyup="setItemQuantity('min')">
              </div>
              <div class="flexItem">
                {{ locale.max }} <input type="text" class="input sizeS" v-model="quantity.max" @keyup="setItemQuantity('max')">
              </div>
            </div>
            <div class="mb10">
              <div class="checkbox">
                <input type="checkbox" id="select_option_by_quantity" v-model="selectOptionByQuantity">
                <label for="select_option_by_quantity">{{ locale.shop_per_quantity_option }}</label>
              </div>
            </div>
            <!-- 인원 기준 수량 -->
            <div class="mb15">
              <p class="mb5"><strong>{{ locale.guest_basis }}</strong></p>
              <p class="sysMessage">{{ locale.message_per_guest }}</p>
              <div class="flexContainer">
                <div class="flexItem">
                  <span class="checkbox">
                    <input type="radio" name="quantity_per_guest" id="quantity_per_guest_none" :value="false" v-model="quantityByGuest">
                    <label for="quantity_per_guest_none">{{ locale.not_applied }}</label>
                  </span>
                </div>
                <div class="flexItem">
                  <span class="checkbox">
                    <input type="radio" name="quantity_per_guest" id="quantity_per_guest_count" :value="true" v-model="quantityByGuest">
                    <label for="quantity_per_guest_count">{{ locale.per_guest }}</label>
                  </span>
                </div>
              </div>
            </div>
            <!-- //인원 기준 수량 -->

            <!-- 1인기준일 때 카운트하지 않을 인원그룹 -->
            <div v-if="quantityByGuest && guestTypeItems?.length > 0" class="mb15">
              <p class="mb5"><strong>{{ locale.exclude_guest_group }}</strong></p>
              <ul>
                <li v-for="guestType in guestTypeItems"
                  :key="guestType.groupId">
                  <div class="checkbox">
                    <input type="checkbox" :id="`guest_group_${guestType.groupId}`" :value="guestType.groupId" v-model="excludeGuestGroupIds">
                    <label :for="`guest_group_${guestType.groupId}`">{{ guestType.groupName[defaultLang] }}</label>
                  </div>
                </li>
              </ul>
            </div>
            <!-- 1인기준일 때 카운트하지 않을 인원그룹 -->

            <!-- 주문 기준 수량 -->
            <div class="mb10">
              <strong>{{ locale.order_basis }}</strong>
              <div class="flexContainer">
                <div class="flexItem">
                  <span class="checkbox">
                    <input type="radio" name="quantity_per_order" id="quantity_per_order_count" :value="false" v-model="quantityByOrder">
                    <label for="quantity_per_order_count">{{ locale.per_order }}</label>
                  </span>
                </div>
                <div class="flexItem">
                  <span class="checkbox">
                    <input type="radio" name="quantity_per_order" id="quantity_per_order_total" :value="true" v-model="quantityByOrder">
                    <label for="quantity_per_order_total">{{ locale.total_orders }}</label>
                  </span>
                </div>
              </div>
            </div>
            <!-- //주문 기준 수량 -->
          </div>
          <!-- //수량 -->
          <!-- 주문 제한 무시 -->
          <div class="">
            <div class="innerTitle setLabel">{{ locale.ignore_order_limits }}</div>
            <div class="mb10">
              <div class="checkbox mb5">
                <input type="checkbox" id="ignore_limit_waiting_time" v-model="ignoreLimit.waiting">
                <label for="ignore_limit_waiting_time">{{ locale.ignore_order_waiting }}</label>
              </div>
              <p class="sysMessage">{{ locale.message_ignore_order_waiting }}</p>
            </div>
            <div>
              <div class="checkbox mb5">
                <input type="checkbox" id="ignore_limit_order_count" v-model="ignoreLimit.count">
                <label for="ignore_limit_order_count">{{ locale.ignore_order_count }}</label>
              </div>
              <p class="sysMessage">{{ locale.message_ignore_order_count }}</p>
            </div>
          </div>
          <!-- //주문 제한 무시 -->
        </div>
        <div v-if="!isCallStaff" class="info">
          <div class="mb30">
            <div class="innerTitle setLabel">{{locale.thumbnail}}</div>
            <p class="mb5 sysMessage">{{locale.shop_optimized_img_size}}</p>
            <div v-if="thumb" class="bgThumb">
              <img :src="thumb" alt="" />
              <button type="button" class="delThumb" @click="deleteThumb"><img src="~@/assets/img/ico_close.svg" alt=""></button>
            </div>
            <div v-else>
              <label class="btn btnFull btnWhite toUppercase">
                {{locale.upload}}
                <input type="file" @change="uploadImage($event)">
              </label>
            </div>
          </div>
          <div class="mb30">
            <div class="innerTitle setLabel">{{locale.desc}}</div>
            <button class="btn btnWhite btnFull toUppercase" @click="openCompositeItemDetail">{{ locale.setting }}</button>
          </div>
          <!-- 옵션 -->
          <div class="mb30">
            <div class="innerTitle setLabel">{{locale.option}}</div>
            <button class="btn btnWhite btnFull toUppercase" @click="openCompositeOption">{{ locale.setting }}</button>
            <div v-if="option && option.length > 0" class="mb10">
              <div class="mt5">
                <div class="checkbox">
                  <input type="checkbox" id="display_option_direct" v-model="directOption">
                  <label for="display_option_direct">{{ locale.shop_direct_option }}</label>
                </div>
              </div>
              <div class="mt5">
                <div class="checkbox">
                  <input type="checkbox" id="pass_first_option" v-model="passFirstOption">
                  <label for="pass_first_option">{{ locale.option_auto_selection }}</label>
                </div>
                <div class="mt5">
                  <p class="sysMessage">{{ locale.message_option_auto_selection }}</p>
                </div>
              </div>
            </div>
          </div>
          <!-- //옵션 -->
          <!-- 이용시간 -->
          <div class="mb15">
            <div class="innerTitle setLabel">
              {{locale.usage_time}}
            </div>
            <select v-if="preset.availableTime.length > 0" v-model="availableTime" class="input select">
              <option value="">{{locale.not_select}}</option>
              <option
                v-for="(item, index) in preset.availableTime"
                :key="index"
                :value="item.presetId">
                {{ item.presetName }}
              </option>
            </select>
            <div v-else class="input">{{locale.no_preset}}</div>
            <div class="mt5"><p class="sysMessage">{{ locale.message_usage_time }}</p></div>
          </div>
          <!-- //이용시간 -->
          <!-- 읽기전용 시간 -->
          <div class="mb30">
            <div class="innerTitle setLabel">
              {{ locale.readonly_usage_time }}
            </div>
            <select v-if="preset.availableTime.length > 0" v-model="displayTime" class="input select">
              <option value="">{{locale.not_select}}</option>
              <option
                v-for="(item, index) in preset.availableTime"
                :key="index"
                :value="item.presetId">
                {{ item.presetName }}
              </option>
            </select>
            <div v-else class="input">{{locale.no_preset}}</div>
            <div class="mt5"><p class="sysMessage">{{ locale.message_readonly_usage_time }}</p></div>
          </div>
          <!-- //읽기전용 시간 -->
          <div class="mb30">
            <div class="innerTitle setLabel">
              {{locale.promotion}}
            </div>
            <div v-if="preset.promotion.length > 0" class="promotionList">
              <div class="checkbox"
                v-for="(item, index) in preset.promotion"
                :key="index">
                <input
                  type="checkbox"
                  name="item_promotion"
                  :id="`promotion_${item.presetId}`"
                  :value="item.presetId"
                  v-model="promotions">
                <label
                  :for="`promotion_${item.presetId}`">
                  {{ item.presetName }}
                </label>
              </div>
            </div>
            <div v-else class="input">{{locale.no_preset}}</div>
          </div>
          <!-- 판매불가 프리셋 설정 -->
          <div class="">
            <div class="innerTitle setLabel">
              {{locale.disabled_mark}}
            </div>
            <select v-if="preset.status.length > 0" v-model="status" class="input select">
              <option value="">{{locale.not_select}}</option>
              <option
                v-for="(item, index) in preset.status"
                :key="index"
                :value="item.presetId">
                {{ item.presetName }}
              </option>
            </select>
            <div v-else class="input">{{locale.no_preset}}</div>
          </div>
          <!-- //판매불가 프리셋 설정 -->
        </div>
      </div>
      <div class="btns">
        <button v-if="shopItemId !== 'new' && !(isBaseShopPos && pId?.length > 0)" type="button" class="btn btnRed btnLeft btnAuto" @click="delItem">{{ locale.delete }}</button>
        <button type="button" class="btn btnWhite" @click="close">{{ locale.cancel }}</button>
        <button type="button" class="btn btnPrimary" @click="save">{{ locale.save }}</button>
      </div>
    </div>
    <!-- 카테고리 설정 -->
    <ShopCategory
      v-if="shopCategory"
      :locale="locale"
      :defaultLang="defaultLang"
      :isBaseShopPos="isBaseShopPos"
      :category="categoryList"
      :isSelect="true"
      :checkedIds="category"
      :disabledIds="isBaseShopPos ? category : [categoryId]"
      @apply="checkCategory"
      @close="closeShopCategory" />
    <!-- //카테고리 설정 -->
    <!-- 상세 설명 설정 -->
    <CompositeItemDetail
      v-if="compositeItemDetail"
      :locale="locale"
      :shopItemName="name"
      :posItemLang="posItemLang"
      :detailImage="detailImage"
      :detailShopItemName="detailShopItemName"
      :descList="descList"
      @apply="applyDetail"
      @close="closeCompositeItemDetail" />
    <!-- //상세 설명 설정 -->
    <!-- 옵션 설정 -->
    <CompositeOption
      v-if="compositeOption"
      :locale="locale"
      :shopItemId="shopItemId !== 'new' && shopItemId"
      :optionList="option"
      :savedOptionIds="savedOptionIds"
      :mustPosSync="mustPosSync"
      @apply="setOption"
      @close="closeCompositeOption" />
    <!-- //옵션 설정 -->
    <!-- 이용시간 설정 -->
    <CompositeAvailableTime
      v-if="compositeAvailableTime"
      :locale="locale"
      @reload="setAvailableTime"
      @close="closeCompositeAvailableTime" />
    <!-- //이용시간 설정 -->
    <!-- 프로모션 설정 -->
    <CompositePromotion
      v-if="compositePromotion"
      :locale="locale"
      @reload="setPromotion"
      @close="closeCompositePromotion" />
    <!-- //프로모션 설정 -->
    <!-- 프로모션 설정 -->
    <CompositeStatus
      v-if="compositeStatus"
      :locale="locale"
      @reload="setStatus"
      @close="closeCompositeStatus" />
    <!-- //프로모션 설정 -->
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import LANG from '@/common/lang'
import UNIQUE from '@/common/unique'
import regExp from '@/common/regExp'
import ShopCategory from './ShopCategory'
import CompositeItemDetail from './CompositeItemDetail'
import CompositeOption from './CompositeOption'
import CompositeAvailableTime from './CompositeAvailableTime'
import CompositePromotion from './CompositePromotion'
import CompositeStatus from './CompositeStatus'
import SetLanguageValue from '@/components/Util/SetLanguageValue'

export default {
  name: 'CompositeItem',
  props: [
    'locale',
    'shopPageId',
    'catCode',
    'shopItemId',
    'categoryList',
    'defaultLang'
  ],
  components: {
    ShopCategory,
    CompositeItemDetail,
    CompositeOption,
    CompositeAvailableTime,
    CompositePromotion,
    CompositeStatus,
    SetLanguageValue
  },
  computed: {
    isSuperadmin () {
      return this.$store.getters['authentication/getAuthority']
    },
    categoryId () {
      return this.$route.params.categoryId
    },
    getShopResultData () {
      return this.$store.getters['shop/getShopResultData']
    },
    isCallStaff () {
      return this.$route.params.categoryId === 'call-staff'
    },
    excludeTax () {
      const pageProperty = this.$store.getters['shop/getShopProperty'](this.shopPageId)
      return pageProperty?.excludeTax
    }
  },
  created () {
    this.init()
  },
  watch: {
    shopItemId (shopItemId) {
      this.init()
    },
    allowReplaceItemName (isAllowed) {
      this.disabledLangCodes = isAllowed ? [] : this.posItemLang
    }
  },
  data () {
    return {
      isActive: true,
      isBaseShopPos: false,
      name: LANG.valueObj(''),
      title: '',
      allowReplaceItemName: false,
      pId: '',
      price: '0',
      priceInfo: {},
      quantity: {
        min: 1,
        max: 10
      },
      inventory: 999,
      thumb: '',
      directOption: false,
      passFirstOption: false,
      isOptItem: false, // 옵션으로 사용중인 상품?
      selectOptionByQuantity: false, // 수량에 따라 옵션 개별 설정 가능?
      option: [],
      replaceOptionPrice: false,
      savedOptionIds: [],
      category: [],
      detailImage: [],
      detailShopItemName: {
        active: false,
        allowReplaceItemName: false,
        shopItemName: this.$store.getters['setting/getLangValues']()
      },
      descList: null,
      availableTime: '',
      displayTime: '', // 주문할수없는 상태일때의 노출시간 (값이 있으면 availableTime 대신 계산됨)
      isCallItem: false, // 주문은 하되 주문내역에 남지 않아야 하는 아이템(센터나 마스터에만 오더전송, pId가 없어야함)
      excludeGuestGroupIds: [], // 수량제한 계산시 제외되어야 하는 인원그룹ids
      promotion: '', // 추후 삭제예정 (promotions로 대체)
      promotions: [],
      status: '',
      mustPosSync: false,
      preset: {
        availableTime: [],
        promotion: [],
        status: []
      },
      quantityByGuest: false, // 1인기준수량?
      quantityByOrder: false, // 총주문기준수량?
      ignoreLimit: {
        waiting: false,
        count: false
      },
      shopCategory: false,
      compositeItemDetail: false,
      compositeOption: false,
      compositeAvailableTime: false,
      compositePromotion: false,
      compositeStatus: false,
      disabledLangCodes: [],
      duplicateWithPid: false,
      guestTypeItems: []
    }
  },
  methods: {
    async init () {
      this.getGuestTypeItems()
      if (this.shopItemId === 'new') {
        this.category.push(this.categoryId)
      }
      await this.getPresetList()
      if (this.shopItemId !== 'new') {
        this.getShopItem()
      }
    },
    async getShopItem () {
      const data = {
        pageId: this.shopPageId,
        shopItemId: this.shopItemId
      }
      const getItem = await this.$store.dispatch('shop/getShopItem', data)
      const item = getItem && getItem.message
      if (item) {
        const nextDetailShopItemName = item.detailShopItemName || {}
        this.isActive = item.isActive !== false
        this.isBaseShopPos = item.isBaseShopPos ?? false
        this.title = item.title || ''
        this.name = item.shopItemName
        this.allowReplaceItemName = item.allowReplaceItemName === true
        this.pId = item.pId
        this.quantity = {
          min: item.quantity?.min || 1,
          max: item.quantity?.max || 10
        }
        this.price = this.excludeTax ? item.priceInfo.net : item.priceInfo.gross
        this.priceInfo = item.priceInfo
        this.category = item.category.map(x => x.categoryId)
        this.thumb = item.thumb
        this.thumbOrigin = item.thumbOrigin || item.thumb
        this.detailImage = item.detailImage
        this.detailShopItemName = {
          ...this.detailShopItemName,
          ...nextDetailShopItemName,
          shopItemName: {
            ...this.detailShopItemName.shopItemName,
            ...(nextDetailShopItemName.shopItemName && Object.keys(nextDetailShopItemName.shopItemName).length
              ? nextDetailShopItemName.shopItemName
              : {})
          }
        }
        this.descList = item.descList || []
        this.directOption = item.directOption || false
        this.isOptItem = item.isOptItem || false
        this.option = item.option?.map(x => {
          return {
            ...x,
            ...x.optionItems && {
              optionItems: x.optionItems?.map(o => {
                return {
                  ...o,
                  name: o.name, // 상품이 선택사항 || 직접추가한 선택사항
                  price: (o.priceInfo?.gross) || o.price || '',
                  quantity: {
                    max: (o.quantity?.max) || 1
                  }
                }
              })
            }
          }
        })
        this.replaceOptionPrice = item.replaceOptionPrice || false
        this.availableTime = item.availableTime?.presetId || ''
        this.displayTime = item.displayTime || ''
        this.promotions = item.promotions || (item.promotion ? [item.promotion?.presetId] : [])
        this.status = item.status?.presetId || ''
        this.mustPosSync = item.mustPosSync || false
        /**
         * 250916 기준
         * 아이템 프로퍼티가 계속 늘어남에 따라
         * 테이블을 별도로 가져가는걸로 변경하여
         * 이후 추가되는 프로퍼티는 itemOptProperty 객체로 전달
         */
        if (item.itemOptProperty) {
          this.selectOptionByQuantity = item.itemOptProperty.selectOptionByQuantity || false
          this.quantityByGuest = item.itemOptProperty.quantityByGuest || false
          this.quantityByOrder = item.itemOptProperty.quantityByOrder || false
          this.ignoreLimit = {
            ...this.ignoreLimit,
            ...item.itemOptProperty.ignoreLimit
          }
          this.passFirstOption = item.itemOptProperty.passFirstOption || false
          this.excludeGuestGroupIds = item.itemOptProperty.excludeGuestGroupIds || []
          this.isCallItem = item.itemOptProperty.isCallItem || false
        }
        // 저장 유무에 따라 옵션정보 호출하는 api가 달라지기 때분에 분리를 위해 필요 (프리셋id는 필요없음)
        this.savedOptionIds = item.option && item.option.length && item.option.filter(x => x.id || x.optionId).map(x => x.id || x.optionId)
        this.posItemLang = item.posItemLang || []
        this.disabledLangCodes = this.allowReplaceItemName ? [] : (item.posItemLang || [])
      }
    },
    async getPresetList () {
      this.$store.commit('onLoading', true)
      await this.getAvailableTimePreset()
      await this.getPromotionPreset()
      this.getStatusPreset()
      this.$store.commit('onLoading', false)
    },
    async getAvailableTimePreset () {
      const getAvailableTime = await this.$store.dispatch('shop/getShopPresetList', 'availableTime')
      const availableTimeList = getAvailableTime && getAvailableTime.message && getAvailableTime.message.preset
      if (availableTimeList) {
        this.preset.availableTime = availableTimeList
      }
      return getAvailableTime
    },
    async getPromotionPreset () {
      const getPromotion = await this.$store.dispatch('shop/getShopPresetList', 'promotion')
      const promotionList = getPromotion && getPromotion.message && getPromotion.message.preset
      if (promotionList) {
        this.preset.promotion = promotionList
      }
      return getPromotion
    },
    async getStatusPreset () {
      const getStatus = await this.$store.dispatch('shop/getShopPresetList', 'status')
      const statusList = getStatus && getStatus.message && getStatus.message.preset
      if (statusList) {
        this.preset.status = statusList
      }
      return getStatus
    },
    async getGuestTypeItems () {
      const guestTypeItems = await this.$store.dispatch('shop/getGuestTypeItems', this.catCode)
      const items = guestTypeItems?.message
      this.guestTypeItems = items || []
    },
    uploadImage (e) {
      const data = {
        id: UNIQUE.mid(),
        file: e.target.files[0],
        // addThumb: true
      }
      const isImage = regExp.image.test(data.file.name.slice(data.file.name.lastIndexOf('.') + 1).toLowerCase())
      if (isImage) {
        this.$store.dispatch('util/uploadFile', data).then((res) => {
          // this.thumb = res.thumbSource
          // this.thumbOrigin = res.source
          this.thumb = res.source
          e.target.value = ''
        })
      } else {
        alert(this.locale.validate_upload_image)
      }
    },
    deleteThumb () {
      this.thumb = ''
      this.thumbOrigin = ''
    },
    close () {
      this.$emit('close')
    },
    openShopCategory () {
      this.shopCategory = true
    },
    closeShopCategory () {
      this.shopCategory = false
    },
    openCompositeItemDetail () {
      this.compositeItemDetail = true
    },
    closeCompositeItemDetail () {
      this.compositeItemDetail = false
    },
    openCompositeOption () {
      this.compositeOption = true
    },
    closeCompositeOption () {
      this.compositeOption = false
    },
    openCompositeAvailableTime () {
      this.compositeAvailableTime = true
    },
    closeCompositeAvailableTime () {
      this.compositeAvailableTime = false
    },
    openCompositePromotion () {
      this.compositePromotion = true
    },
    closeCompositePromotion () {
      this.compositePromotion = false
    },
    openCompositeStatus () {
      this.compositeStatus = true
    },
    closeCompositeStatus () {
      this.compositeStatus = false
    },
    checkCategory (ids) {
      this.category = ids
    },
    async setAvailableTime (presetId) {
      await this.getAvailableTimePreset()
      this.availableTime = presetId
    },
    async setPromotion (presetId) {
      await this.getPromotionPreset()
      this.promotion.push(presetId)
    },
    async setStatus (presetId) {
      await this.getStatusPreset()
      this.status = presetId
    },
    async setOption (option) {
      if (option) {
        this.option = option
      }
    },
    setPrice () {
      const val = this.price
      const value = regExp.priceInput(val)
      this.price = value
    },
    setItemQuantity (target) {
      const val = this.quantity[target]
      const value = regExp.naturalNumberOnly(val)
      this.quantity[target] = parseInt(value) || ''
    },
    setDetailShopItemName (isActive) {
      if (isActive && !this.detailShopItemName.shopItemName[this.defaultLang]) {
        this.detailShopItemName.shopItemName = this._.cloneDeep(this.name)
      }
    },
    applyDetail (data) {
      this.detailImage = data.detailImage
      // 여기부터 상세정보 순서(추가정보 프리셋 포함) 설정해야 함
      this.descList = data.descList
    },
    // 삭제 전 아이템이 어디 옵션 선택사항에 지정되어 있는지 체크해야함
    async checkUseShopItem () {
      try {
        const res = await this.$store.dispatch('shop/checkUseShopItem', this.shopItemId)
        const useOptionItems = (res && res.message && res.message.useOptionItems) || []
        if (useOptionItems.length > 0) {
          const useItemNames = useOptionItems.map(x => x.name[this.defaultLang]).join(', ')
          alert(`${this.locale.shop_item_set_as_optional.replace('{var}', useOptionItems.length)}\n(${useItemNames})`)
          return false
        } else {
          return true
        }
      } catch (error) {
        console.error('checkUsePreset error:', error)
        return false
      }
    },
    async delItem () {
      const isConfirmed = await this.checkUseShopItem()
      if (isConfirmed) {
        const data = {
          pageId: this.shopPageId,
          shopItemId: this.shopItemId
        }
        this.$store.commit('onLoading', true)
        const res = await this.$store.dispatch('shop/delShopItem', data)
        if (res && res.status === 200) {
          alert(this.locale.complete_delete)
          this.$emit('completeDelete')
        } else {
          const status = (res && res.message && res.message.code) || 500
          const message = this.getShopResultData(status)
          alert(message)
        }
        this.$store.commit('onLoading', false)
      }
    },
    isItemValid () {
      const hasPid = typeof this.pId === 'string'
        ? this.pId.length > 0
        : Array.isArray(this.pId)
          ? this.pId.length > 0
          : !!this.pId

      const invalid = this.isBaseShopPos === true && hasPid && this.isCallItem === true

      if (invalid) {
        alert('식별코드가 있는 상품은 주문내역에서 제외할 수 없습니다.')
        return false
      }

      return true
    },
    async saveItem (isDuplicate) {
      const shopItemId = this.shopItemId !== 'new' && this.shopItemId
      const data = {
        isActive: this.isActive,
        isCallItem: this.isCallItem,
        pageId: this.shopPageId,
        shopItemId: isDuplicate
          ? UNIQUE.uniqueId8()
          : shopItemId || UNIQUE.uniqueId8(),
        shopItemName: this.$store.getters['util/filteredLanguageValues'](this.name),
        allowReplaceItemName: this.allowReplaceItemName,
        category: this.category.filter(x => x !== 'unknown'),
        quantity: this.quantity,
        ...this.title && {
          title: this.title
        },
        ...this.pId && {
          pId: (isDuplicate && this.duplicateWithPid === false)
            ? ''
            : this.pId || ''
        },
        ...this.availableTime && {
          availableTime: this.availableTime
        },
        ...this.displayTime && {
          displayTime: this.displayTime
        },
        ...this.promotions && {
          promotions: this.promotions
        },
        ...this.status && {
          status: this.status
        },
        ...this.thumb && {
          thumb: this.thumb,
          thumbOrigin: this.thumbOrigin
        },
        ...this.descList && {
          descList: this.descList.filter(x => x.desc || x.presetId).map(x => x.desc ? x : x.presetId)
        },
        ...this.detailImage && this.detailImage.length && {
          detailImage: this.detailImage
        },
        ...this.option && this.option.length && {
          option: this.option.map(x => {
            return x.id
              ? { id: x.id, activeItemIds: x.activeItemIds }
              : x.presetId
                ? { presetId: x.presetId }
                : x
          })
        },
        directOption: this.directOption,
        selectOptionByQuantity: this.selectOptionByQuantity,
        replaceOptionPrice: this.replaceOptionPrice,
        quantityByGuest: this.quantityByGuest,
        quantityByOrder: this.quantityByOrder,
        excludeGuestGroupIds: this.excludeGuestGroupIds,
        ignoreLimit: this.ignoreLimit,
        priceInfo: {
          gross: this.price,
          ...this.priceInfo,
          ...this.excludeTax ? {
            net: this.price
          } : {
            gross: this.price
          }
        },
        detailShopItemName: this.detailShopItemName,
        passFirstOption: this.passFirstOption,
      }
      const method = isDuplicate || (this.shopItemId && this.shopItemId === 'new')
        ? 'shop/createShopItem'
        : 'shop/updateShopItem'
      try {
        const res = await this.$store.dispatch(method, data)
        return { ...res, shopItemId: data.shopItemId}
      } catch (ex) {
        alert(this.locale.system_error)
      }
    },
    async save () {
      if (!this.isItemValid()) return

      this.$store.commit('onLoading', true)
      const res = await this.saveItem()
      if (res && res.status === 200) {
        this.$emit('completeSave', res.shopItemId)
        this.$emit('close')
      } else {
        const status = (res && res.message && res.message.code) || 500
        const message = this.getShopResultData(status)
        alert(message)
      }
      this.$store.commit('onLoading', false)

    },
    async duplicateItem (isReplace) {
      if (!this.isItemValid()) return
      try {
        this.$store.commit('onLoading', true)
        const save = await this.saveItem(true) // 복제한 새 아이템 저장
        if (save?.status !== 200) {
          alert(save?.message?.message)
          this.$emit('completeDelete')
          return
        }
        // isduplicateWithReplace 이면 this.category = [] 변경 후 save() 아니면 그냥 $emit.completeDelete
        if (isReplace) {
          this.category = [] // 원본아이템 카테고리 해제 후 저장
          await this.save() // is add item
        } else {
          this.$emit('completeDelete')
        }
      } catch (ex) {
        alert(this.locale.system_error)
      } finally {
        this.$store.commit('onLoading', false)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.layer {
  .inner {
    max-width: 800px;
  }
  .inner520 {
    max-width: 520px;
  }
}
.innerContent {
  display: flex;
  flex: 1;
  overflow: hidden;
  .info {
    flex: 1;
    overflow: auto;
    & + .info {
      margin-left: 30px;
    }
  }
}
.isRequired {
  .innerTitle {
    padding-left: 18px;
    &:after {
      content: "*";
      position: absolute;
      top: 0;
      left: 8px;
      color: $color-red;
    }
  }
}
.promotionList {
  .checkbox {
    display: block;
    margin-right: 0;
  }
}
.layerTitle {
  position: relative;
  .duplicateShopItem {
    position: absolute;
    top: -30px;
    right: -30px;
    padding: 4px 4px 4px 8px;
    font-size: 14px;
    font-weight: normal;
    border-left: 1px solid $color-lgrey2;
    border-bottom: 1px solid $color-lgrey2;
    border-radius: 0 4px 0 4px;
    background-color: $color-white;
  }
  .btn {
    padding-left: 8px;
    padding-right: 8px;
  }
}
</style>
